module.exports = __webpack_public_path__ + "fonts/junction-regular.165ad9c1.eot";